/**
 * Main JavaScript file for the theme
 * Note: All libraries are loaded via Gulp concatenation from node_modules
 */

// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
	// Mobile menu toggle
	const menuToggle = document.querySelector('.menu-toggle');
	const mainNavigation = document.querySelector('.main-navigation');

	if (menuToggle) {
		menuToggle.addEventListener('click', () => {
			mainNavigation.classList.toggle('toggled');

			if (mainNavigation.classList.contains('toggled')) {
				menuToggle.setAttribute('aria-expanded', 'true');
			} else {
				menuToggle.setAttribute('aria-expanded', 'false');
			}
		});
	}

	// Initialize Swiper sliders
	initializeSwipers();

	// Initialize Fancybox
	initializeFancybox();

	// Smooth scroll for anchor links
	document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((anchor) => {
		anchor.addEventListener('click', function (e) {
			const target = document.querySelector(this.getAttribute('href'));

			if (target) {
				e.preventDefault();

				window.scrollTo({
					top: target.offsetTop - 100,
					behavior: 'smooth',
				});
			}
		});
	});

	// Add responsive table wrapper
	document.querySelectorAll('table').forEach((table) => {
		if (!table.closest('.table-responsive')) {
			const wrapper = document.createElement('div');
			wrapper.className = 'table-responsive';
			table.parentNode.insertBefore(wrapper, table);
			wrapper.appendChild(table);
		}
	});

	// Add external link icon and target="_blank"
	document.querySelectorAll('a').forEach((link) => {
		const url = link.href;

		if (url && url.indexOf(window.location.hostname) === -1 && url.startsWith('http')) {
			link.setAttribute('target', '_blank');
			link.setAttribute('rel', 'noopener noreferrer');

			// Only add icon if it doesn't contain an image
			if (!link.querySelector('img')) {
				link.classList.add('external-link');
			}
		}
	});
});

/**
 * Initialize Fancybox
 */
function initializeFancybox() {
	// Check if Fancybox is available (it should be loaded via Gulp)
	if (typeof window.Fancybox === 'undefined') {
		console.warn('Fancybox is not loaded');
		return;
	}

	// Bind Fancybox to all images with data-fancybox attribute
	window.Fancybox.bind('[data-fancybox]', {
		// Global options
		Toolbar: {
			display: {
				left: ['infobar'],
				middle: ['zoomIn', 'zoomOut', 'toggle1to1', 'rotateCCW', 'rotateCW', 'flipX', 'flipY'],
				right: ['slideshow', 'thumbs', 'close'],
			},
		},
		Thumbs: {
			autoStart: false,
		},
	});

	// Bind Fancybox to WordPress galleries
	window.Fancybox.bind('.gallery a', {
		groupAll: true, // Group all gallery images together
	});

	// Bind Fancybox to WordPress attachment pages
	window.Fancybox.bind('.wp-block-image a', {
		groupAll: true,
	});

	// Custom Fancybox for videos
	window.Fancybox.bind('[data-fancybox-video]', {
		// Video-specific options
	});
}

/**
 * Initialize all Swiper sliders on the page
 */
function initializeSwipers() {
	// Check if Swiper is available (it should be loaded via Gulp)
	if (typeof window.Swiper === 'undefined') {
		console.warn('Swiper is not loaded');
		return;
	}

	// Basic Hero Slider
	const heroSlider = document.querySelector('.hero-slider');
	if (heroSlider) {
		new window.Swiper('.hero-slider', {
			loop: true,
			// autoplay: {
			// 	delay: 5000,
			// 	disableOnInteraction: false,
			// },
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	}

	// Cards/Content Slider
	const cardsSlider = document.querySelector('.event-cards-slider');
	if (cardsSlider) {
		new window.Swiper('.event-cards-slider', {
			loop: false,
			spaceBetween: 30,
			centeredSlides: false,
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			navigation: {
				nextEl: '.event-card-next',
				prevEl: '.event-card-prev',
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		});
	}

	const singleNewsSlider = document.querySelector('.singular-news-carousel');
	if (singleNewsSlider) {
		new window.Swiper('.singular-news-carousel', {
			loop: false,
			spaceBetween: 30,
			centeredSlides: true,
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			navigation: {
				nextEl: '.singular-nav-next',
				prevEl: '.singular-nav-prev',
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 1,
				},
				1024: {
					slidesPerView: 1,
				},
			},
		});
	}

}

/**
 * Utility function to create a basic slider programmatically
 * @param {string} selector - CSS selector for the slider container
 * @param {object} options - Swiper options
 */
function createSwiper(selector, options = {}) {
	const element = document.querySelector(selector);
	if (!element || typeof window.Swiper === 'undefined') {
		return null;
	}

	const defaultOptions = {
		loop: true,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
	};

	const mergedOptions = Object.assign({}, defaultOptions, options);
	return new window.Swiper(selector, mergedOptions);
}

// Make functions available globally
window.createCustomSwiper = createSwiper;
window.initializeFancybox = initializeFancybox;

// Mobile Menu
document.addEventListener('DOMContentLoaded', function () {
	const menuToggle = document.querySelector('.navbar-toggler');
	const mainNav = document.querySelector('.main-navigation-wrapper');
	const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

	// Mobile menu toggle
	if (menuToggle && mainNav) {
		menuToggle.addEventListener('click', function () {
			this.classList.toggle('active');
			mainNav.classList.toggle('mobile-active');
			document.body.classList.toggle('menu-open');
		});
	}

	// Dropdown toggles
	if (dropdownToggles) {
		dropdownToggles.forEach((toggle) => {
			toggle.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				// Toggle active state
				this.classList.toggle('active');

				// Find and toggle dropdown
				const dropdown = this.parentNode.querySelector('.menu-dropdown');
				if (dropdown) {
					dropdown.classList.toggle('show');
				}
			});
		});
	}

	// Close menu when clicking outside
	document.addEventListener('click', function (e) {
		if (window.innerWidth <= 1270) {
			if (!mainNav.contains(e.target) && !menuToggle.contains(e.target)) {
				mainNav.classList.remove('mobile-active');
				menuToggle.classList.remove('active');
				document.body.classList.remove('menu-open');
			}
		}
	});

	// Handle window resize
	let resizeTimer;
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			if (window.innerWidth > 1270) {
				mainNav.classList.remove('mobile-active');
				menuToggle.classList.remove('active');
				document.body.classList.remove('menu-open');
				document.querySelectorAll('.menu-dropdown.show').forEach((dropdown) => {
					dropdown.classList.remove('show');
				});
			}
		}, 250);
	});
});


(function($) {
	'use strict';
	$(document).ready(function() {
			const loadMoreBtn = $('#load-more-courses');
			const coursesGrid = $('.courses-grid');
			let currentPage = 1;
			let loading = false;

			// Debug check
			console.log('Load more params:', courses_loadmore_params);

			loadMoreBtn.on('click', function(e) {
					e.preventDefault();

					if (loading) return;

					loading = true;
					loadMoreBtn.text('Loading...');
					currentPage++;

					// Debug log
					console.log('Sending AJAX request:', {
							url: courses_loadmore_params.ajaxurl,
							action: courses_loadmore_params.action,
							nonce: courses_loadmore_params.nonce,
							page: currentPage
					});

					$.ajax({
							url: courses_loadmore_params.ajaxurl,
							type: 'POST',
							dataType: 'json',
							data: {
									action: 'load_more_courses',
									nonce: courses_loadmore_params.nonce,
									page: currentPage
							},
							success: function(response) {
									console.log('AJAX success:', response);

									if (response.html) {
											const $newElements = $(response.html).hide();
											coursesGrid.append($newElements);
											$newElements.fadeIn(800);

											if (currentPage >= response.max_pages) {
													loadMoreBtn.fadeOut(400);
											}
									}
									loading = false;
									loadMoreBtn.text('Load More Courses');
							},
							error: function(xhr, status, error) {
									console.error('AJAX error:', {
											status: status,
											error: error,
											response: xhr.responseText
									});
									loading = false;
									loadMoreBtn.text('Load More Courses');
							}
					});
			});
	});
})(jQuery);

(function($){
  'use strict';
  $(function(){
    var $grid      = $('.smart-talk-grid');
    var $btn       = $('#load-more-smart-talks');
    var $filter    = $('#smartTalkFilter');
    var $search    = $('#smartTalkSearch');
    var $searchBtn = $('#smartTalkSearchBtn');

    var perPage = 3, currentPage = 1, loading = false;

    function setQS(obj){
      var url = new URL(window.location.href);
      $.each(obj, function(k,v){
        v = (v||'').toString().trim();
        if (v) url.searchParams.set(k,v); else url.searchParams.delete(k);
      });
      history.pushState({},'',url.toString());
    }

    function request(page, append){
      if (loading) return;
      loading = true;

      // show loading state for fresh fetch
      if (!append && page === 1) {
        $grid.html('<p class="mb-0 h3 text-center">Loading Smart Talks...</p>');
      }

      $btn.text('Loading...').prop('disabled', true);

      $.ajax({
        url: courses_loadmore_params.ajaxurl,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'load_more_smart_talk',
          nonce: courses_loadmore_params.nonce,
          page: page,
          per_page: perPage,
          st_cat: $filter.val() || '',
          q: $search.val() || '',
          context: 'smart_talks'
        }
      })
      .done(function(res){
        var html = res && res.html ? res.html : '';
        var max  = res && res.max_pages ? parseInt(res.max_pages,10) : 1;

        if (!append){
          $grid.html(html || '<p class="mb-0 h3 text-center">No Smart Talks Found...</p>');
          currentPage = 1;
        } else if (html){
          $(html).hide().appendTo($grid).fadeIn(250);
          currentPage = page;
        }

        if (currentPage >= max || !html) $btn.hide(); else $btn.show();
      })
      .always(function(){
        loading = false;
        $btn.text('Load More').prop('disabled', false);
      });
    }

    function applyFilters(){
      setQS({ st_cat: $filter.val()||'', q: $search.val()||'' });
      request(1, false);
    }

    // Events
    $filter.on('change', applyFilters);
    $searchBtn.on('click', applyFilters);
    $search.on('keydown', function(e){ if (e.key === 'Enter'){ e.preventDefault(); applyFilters(); } });
    $btn.on('click', function(e){ e.preventDefault(); request(currentPage+1, true); });

    // Initialize from URL & auto-fetch if params
    var url    = new URL(window.location.href);
    var urlCat = url.searchParams.get('st_cat')||'';
    var urlQ   = url.searchParams.get('q')||'';

    if (urlCat) $filter.val(urlCat);
    if (urlQ)   $search.val(urlQ);

    if (urlCat || urlQ) {
      // trigger filtered fetch; Load More button will be toggled by response
      request(1, false);
    }
  });
})(jQuery);
